import { ContentSettingApi } from '@/apis';
import BaseStore from './BaseStore';
import RootStore from '.';
import { flow, makeObservable, observable } from 'mobx';
import { ContentSetting } from '@/types/content-setting';
import { ResponseData } from '@/types/http';
import { GetContentSettingRequest, PostContentSettingRequest } from '@/types/http-payload/content-setting';

export default class ContentSettingStore extends BaseStore {
    kilometerLimitCMS: ContentSetting = {} as ContentSetting;

    api: ContentSettingApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            kilometerLimitCMS: observable,
            getCompanyIntroduction: flow.bound,
            createOrUpdateCompanyIntroduction: flow.bound,
            getCompanyIntroductionEnduser: flow.bound,
            getPrivacyPolicy: flow.bound,
            createOrUpdatePrivacyPolicy: flow.bound,
            getPrivacyPolicyEnduser: flow.bound,
            getTermsAndConditions: flow.bound,
            createOrUpdateTermsAndConditions: flow.bound,
            getTermsAndConditionsEnduser: flow.bound,
            getSpecialCommercial: flow.bound,
            createOrUpdateSpecialCommercial: flow.bound,
            getSpecialCommercialEnduser: flow.bound,
            getCancellationPolicy: flow.bound,
            createOrUpdateCancellationPolicy: flow.bound,
            getCancellationPolicyEnduser: flow.bound
        });
        this.api = new ContentSettingApi();
    }
    // #region CMS

    *getCompanyIntroduction() {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getCompanyIntroduction);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *createOrUpdateCompanyIntroduction(payload: PostContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.createOrUpdateCompanyIntroduction, payload);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getPrivacyPolicy() {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getPrivacyPolicy);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *createOrUpdatePrivacyPolicy(payload: PostContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.createOrUpdatePrivacyPolicy, payload);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getTermsAndConditions() {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getTermsAndConditions);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *createOrUpdateTermsAndConditions(payload: PostContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.createOrUpdateTermsAndConditions, payload);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getSpecialCommercial() {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getSpecialCommercial);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *createOrUpdateSpecialCommercial(payload: PostContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.createOrUpdateSpecialCommercial, payload);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getCancellationPolicy() {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getCancellationPolicy);
            if (res.ok) {
                this.kilometerLimitCMS = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *createOrUpdateCancellationPolicy(payload: PostContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.createOrUpdateCancellationPolicy, payload);
            if (res.ok) {
                this.kilometerLimitCMS = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }
    // #endregion

    // #region Enduser
    *getCompanyIntroductionEnduser(request: GetContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getCompanyIntroductionEnduser, request);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getPrivacyPolicyEnduser(request: GetContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getPrivacyPolicyEnduser, request);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getTermsAndConditionsEnduser(request: GetContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getTermsAndConditionsEnduser, request);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getSpecialCommercialEnduser(request: GetContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getSpecialCommercialEnduser, request);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getCancellationPolicyEnduser(request: GetContentSettingRequest) {
        try {
            const res: ResponseData<ContentSetting> = yield this.rootStore.apiStore.call(this.api, this.api.getCancellationPolicyEnduser, request);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }
    // #endregion
}
